import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
// import { mapState, mapActions, mapMutations } from 'vuex'
/**
 * WebSocket stomp 实例
 */
class Ws {
    constructor(params = {}) {
        const wsUrl = process.env.VUE_APP_WS_API
        // 重连间隔
        this.reconnectInterval = 10000
        this.header = params.header || {}
        // 是否打印debug信息
        this.debug = true
        this.url = wsUrl
        // stomp实例
        this.client = null
        // 重连事件编号
        this.reconnectId = null
        // 订阅集合
        this.subscribes = {}
        this.connect(this.header)
    }

    /**
     * 创建连接
     */
    connect(header) {
        console.log('connectconnect')
        this.header = header || {}
        // 如已存在连接则不创建
        if (this.client && this.client.connected) {
            return
        }
        console.log('this.url', this.url)
        const ws = new SockJS(this.url)
        this.client = Stomp.over(ws)
        this.client.heartbeat.incoming = 5000
        this.client.heartbeat.outgoing = 5000
        // 监听WebSocket对象连接状态，如失败，则stomp的connect回调不会触发，应在此重连
        ws.onerror = () => {
            // 重连
            this.reconnectId = setTimeout(() => {
                this.reconnect()
            }, this.reconnectInterval)
        }
        // 控制是否打印debug信息
        if (!this.debug) {
            this.client.debug = (info) => {
                console.log('webSocketDebug', info)
            }
        }
        console.log('clientconnect')
        this.client.connect(header,
            frame => {
                // 初始化订阅
                Object.keys(this.subscribes).forEach(key => {
                    this.subscribe(key, this.subscribes[key].callback)
                })
            },
            error => {
                console.log(error)
                // 重连
                this.reconnectId = setTimeout(() => {
                    this.reconnect()
                }, this.reconnectInterval)
            }
        )
    }

    /**
     * 重新连接
     */
    reconnect() {
        // 订阅状态置false
        Object.keys(this.subscribes).forEach(key => {
            this.subscribes[key]['subscribed'] = false
        })
        // 连接
        this.connect(this.header)
    }

    /**
     * 断开连接
     */
    disconnect() {
        // 断开连接
        if (this.client && this.client.connected) {
            this.client.disconnect()
        }
        // 停止重连事件
        if (this.reconnectId) {
            clearTimeout(this.reconnectId)
            this.reconnectId = null
        }
        // 清空所有除订阅缓存
        this.subscribes = {}
    }

    /**
     * 订阅
     * @param {Object} destination 主题
     * @param {Object} callback 回调
     */
    subscribe(destination, callback) {
        // console.log('subscribe')
        // this.connect()
        if (this.subscribes[destination] && this.subscribes[destination]['subscribed']) { // 已订阅
            return false
        } else if (this.client && this.client.connected) { // 已连接：调用订阅，缓存订阅信息
            const subscribe = this.client.subscribe(destination, res => {
                console.log('callback')
                const data = JSON.parse(res.body)
                callback(data)
            })
            this.subscribes[destination] = {
                callback: callback,
                subscribed: true,
                subscribe: subscribe
            }
        } else { // 未连接：缓存订阅信息
            this.subscribes[destination] = {
                callback: callback,
                subscribed: false
            }
        }
    }

    /**
     * 取消订阅
     * @param {Object} destination 主题
     */
    unsubscribe(destination) {
        if (this.subscribes[destination]) {
            // 取消订阅
            this.subscribes[destination].subscribe.unsubscribe()
            // 删除订阅缓存
            delete this.subscribes[destination]
        }
    }

    /**
     * 向服务器发送消息
     * @param {Object} destination 主题
     * @param {Object} message 消息内容
     */
    send(destination, message) {
        if (this.client) {
            this.client.send(destination, null, message)
        }
    }
}

export default Ws
